import {useEffect, useRef, useState} from "react";
import {useIsOpenSidebar, useIsOpenSidebarAction} from "../../context/toggleSidebarContext";
import {useAuth} from "../../context/AuthContext";
import {logout} from "../../services";
import {useNavigate} from "react-router-dom";
import Loading from "../Loading";
export default function Header() {
    const [isShowDropdownNotification, setIsShowDropdownNotification] = useState(false);
    const dropdownNotificationRef = useRef(null);

    const [isShowDropdownUser, setIsShowDropdownUser] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const dropdownUserRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const setIsOpenSidebar = useIsOpenSidebarAction()
    const isOpenSidebar = useIsOpenSidebar();

    const auth = useAuth();

    useEffect(() => {
        document.addEventListener('mousedown', handleDropdownUser);
        document.addEventListener('mousedown', handleDropdownNotification);

        window.addEventListener("scroll", handleScroll);

        return () => {
            document.removeEventListener('mousedown', handleDropdownUser);
            document.removeEventListener('mousedown', handleDropdownNotification);

            window.removeEventListener("scroll", handleScroll);
        };
    }, [])

    const handleScroll = () => {
        if (document.body.scrollTop > 10 || document.documentElement.scrollTop > 10) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false)
        }
    }
    const handleDropdownNotification = (e) => {
        if (dropdownNotificationRef?.current && !dropdownNotificationRef.current.contains(e.target)) {
            setIsShowDropdownNotification(false)
        }
    }
    const handleDropdownUser = (e) => {
        if (dropdownUserRef?.current && !dropdownUserRef.current.contains(e.target)) {
            setIsShowDropdownUser(false)
        }
    }

    const handleLogout = async () => {
        setIsLoading(true);
        try {
            const {isSuccess} = await logout();
            if (isSuccess) {
                navigate('/login')
            }
            setIsLoading(false)
        } catch (ex) {
            console.log(ex);
            setIsLoading(false);
        }
    }

    return (
        <>
            <nav className={`layout-navbar navbar navbar-expand-xl align-items-center bg-navbar-theme ${isScrolled ? "navbar-elevated" : ""}`} id="layout-navbar">
                <div className="container-fluid">
                    <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none"
                         onClick={() => setIsOpenSidebar({...isOpenSidebar, expanded: true})}>
                        <button className="nav-item nav-link px-0 me-xl-4 bg-transparent border-0">
                            <i className="bx bx-menu bx-sm"/>
                        </button>
                    </div>

                    <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
                        <ul className="navbar-nav flex-row align-items-center ms-auto">

                            <li className="nav-item dropdown-notifications navbar-dropdown dropdown me-3 me-xl-2">
                                <button className="nav-link dropdown-toggle hide-arrow border-none" onClick={() => setIsShowDropdownNotification(prevState => !prevState)} ref={dropdownNotificationRef}>
                                    <i className="bx bx-bell bx-sm"></i>
                                    <span className="badge bg-danger rounded-pill badge-notifications">0</span>
                                </button>
                                <ul className={`dropdown-menu dropdown-menu-end py-0 ${isShowDropdownNotification ? "show" : ""}`} data-bs-popper="none">
                                    <li className="dropdown-menu-header border-bottom">
                                        <div className="dropdown-header d-flex align-items-center py-3">
                                            <h5 className="text-body mb-0 me-auto secondary-font">اعلان‌ها</h5>
                                            <a href="javascript:void(0)"
                                               className="dropdown-notifications-all text-body" data-bs-toggle="tooltip"
                                               data-bs-placement="top" title="علامت خوانده شده به همه"><i
                                                className="bx fs-4 bx-envelope-open"></i></a>
                                        </div>
                                    </li>
                                    <li className="dropdown-notifications-list scrollable-container">
                                        <ul className="list-group list-group-flush">
                                            {/*<li className="list-group-item list-group-item-action dropdown-notifications-item">*/}
                                            {/*    <div className="d-flex">*/}
                                            {/*        <div className="flex-shrink-0 me-3">*/}
                                            {/*            <div className="avatar">*/}
                                            {/*                <img src="../../assets/images/logo.png" alt*/}
                                            {/*                     className="w-px-40 h-auto rounded-circle" />*/}
                                            {/*            </div>*/}
                                            {/*        </div>*/}
                                            {/*        <div className="flex-grow-1">*/}
                                            {/*            <h6 className="mb-1">لورم ایپسوم متن ساختگی با</h6>*/}
                                            {/*            <p className="mb-0">لورم ایپسوم متن ساختگی با تولید سادگی*/}
                                            {/*                نامفهوم</p>*/}
                                            {/*            <small className="text-muted">1 ساعت قبل</small>*/}
                                            {/*        </div>*/}
                                            {/*        <div className="flex-shrink-0 dropdown-notifications-actions">*/}
                                            {/*            <a href="javascript:void(0)"*/}
                                            {/*               className="dropdown-notifications-read"><span*/}
                                            {/*                className="badge badge-dot"></span></a>*/}
                                            {/*            <a href="javascript:void(0)"*/}
                                            {/*               className="dropdown-notifications-archive"><span*/}
                                            {/*                className="bx bx-x"></span></a>*/}
                                            {/*        </div>*/}
                                            {/*    </div>*/}
                                            {/*</li>*/}
                                        </ul>
                                    </li>
                                    <li className="dropdown-menu-footer border-top">
                                        <a href="javascript:void(0);"
                                           className="dropdown-item d-flex justify-content-center p-3">
                                            هیچ پیامی ندارید
                                        </a>
                                    </li>
                                </ul>
                            </li>

                            <li className="nav-item me-2 me-xl-0">
                                <button className="nav-link style-switcher-toggle hide-arrow border-0 bg-transparent">
                                    <i className="bx bx-sm"/>
                                </button>
                            </li>
                            <li className="nav-item navbar-dropdown dropdown-user dropdown"
                                onClick={() => setIsShowDropdownUser(prevState => !prevState)} ref={dropdownUserRef}>
                                <button className={`nav-link dropdown-toggle hide-arrow bg-transparent border-0 ${isShowDropdownUser ? "show" : ""}`}
                                   data-bs-toggle="dropdown">
                                    <div className="avatar   p-1">
                                        {/*avatar-online*/}
                                        <i className="bx bx-user-circle me-2 fs-3"/>
                                        {/*<img src="/avatars/1.png" alt="avatar" className="rounded-circle"/>*/}
                                    </div>
                                </button>
                                <ul className={`dropdown-menu dropdown-menu-end ${isShowDropdownUser ? "show" : ""}`}
                                    data-bs-popper="none">
                                    <li>
                                        <div className="dropdown-item">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0 me-3">
                                                    <div className="avatar  mt-1">
                                                        <i className="bx bx-user-circle me-2 fs-3"/>

                                                        {/*<img src="/avatars/1.png" alt="avatar"*/}
                                                        {/*     className="rounded-circle"/>*/}
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <span className="fw-semibold d-block">{`${auth?.userInfo?.firstName} ${auth?.userInfo?.lastName}`}</span>
                                                    {/*<small>مدیر</small>*/}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="dropdown-divider"/>
                                    </li>
                                    <li>
                                        <button className="dropdown-item" onClick={handleLogout}>
                                            <i className="bx bx-power-off me-2"/>
                                            <span className="align-middle">خروج</span>
                                        </button>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            {
                isLoading ? (<Loading />) : null
            }
        </>
    )
}